import { memo, MouseEvent } from 'react'
import { List, ListItem, ListItemButton, SxProps } from '@mui/material'
import clsx from 'clsx'
import Text from '../../Text'
import { dropdownListStyles as styles } from './DropdownList.style'
import { DropdownListProps } from './DropdownList.types'
import { dropdownListClasses } from './DropdownList.data'

const DropdownList = <Options extends object>({
  sx = {},
  options,
  idKey,
  value,
  valueKey,
  labelKey,
  onChange,
  listItemProps = {},
  listItemButtonProps = {},
  listItemTextProps = {},
  ...props
}: DropdownListProps<Options>) => {
  const hasOptions = Boolean(options.length)

  if (!hasOptions) return null

  const {
    className: listItemClassName = '',
    sx: listItemSx,
    onClick: onListItemClick,
    ...otherListItemProps
  } = listItemProps

  const { sx: listItemButtonSx, ...otherListItemButtonProps } = listItemButtonProps
  const { sx: listItemTextSx, ...otherListItemTextProps } = listItemTextProps
  return (
    <List sx={[styles.list, sx] as SxProps} {...props}>
      {options.map((option) => (
        <ListItem
          className={clsx({
            [dropdownListClasses.selectedItem]: option[valueKey] === value,
            [listItemClassName]: listItemClassName,
          })}
          key={option[idKey] as string}
          sx={[styles.listItem, listItemSx] as SxProps}
          onClick={(event: MouseEvent<HTMLLIElement>) => {
            onChange(option)
            onListItemClick?.(event)
          }}
          {...otherListItemProps}>
          <ListItemButton
            sx={[styles.listItemButton, listItemButtonSx] as SxProps}
            {...otherListItemButtonProps}>
            <Text sx={[styles.listItemText, listItemTextSx] as SxProps} {...otherListItemTextProps}>
              {option[labelKey] as string}
            </Text>
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  )
}

export default memo(DropdownList) as unknown as typeof DropdownList
